import { Message } from './types';

export const messages: Message = {
	toDo: 'To Do',
	inProgress: 'In Progress',
	done: 'Done',
	todoStaticLabel: 'Design AI shopping suggestions for homepage',
	inProgStaticLabel1: 'Create AI-generated shopping suggestions for homepage',
	inProgStaticLabel2: 'Add advanced analytics tracking events',
	doneStaticLabel1: 'Improve payment checkout time on mobile',
	doneStaticLabel2: 'Define requirements to use new AI integrations',
	animatedCardHeading: 'Design new billing API',
	createIssueModalIssueTypeAssetLabel1: 'Issue type: Task',
	createIssueModalIssueTypeAssetLabel2: 'Issue type: Story',
	createIssueModalIssueTypeAssetLabel3: 'Issue type: Bug',
	createIssueModalPriorityAssetLabel1: 'Priority: High',
	createIssueModalPriorityAssetLabel2: 'Priority: Critical',
	createIssueModalPriorityAssetLabel3: 'Priority: Blocker',
	createIssueModalPriorityAssetLabel4: 'Priority: Minor',
	createIssueModalAssigneeAssetLabel1: 'Assignee: Alvin',
	createIssueModalAssigneeAssetLabel2: 'Assignee: Jane',
	createIssueModalAssigneeAssetLabel3: 'Assignee: Blake',
	epicNameFeatures: 'features',
	epicNameAnalytics: 'analytics',
	epicNamePayments: 'payments',
	epicNameAssets: 'assets',
	epicNameStrategy: 'strategy',
	epicNameBudget: 'budget',
	epicNameQ1Campaign: 'q1 campaign',
	priorityHigh: 'high',
	priorityCritical: 'critical',
	priorityMinor: 'minor',
	priorityBlocker: 'blocker',
	issueTypeBug: 'bug',
	issueTypeStory: 'story',
	issueTypeTask: 'task',
};
